import { browserTracingIntegration, replayIntegration, init } from "@sentry/vue";

import type { TcRouter } from "@/Router/Routes";
import type { App } from "vue";

import { config } from "@/Common/envConfig";

import { isValidString } from "@/Utils/String";
import { hasValue } from "@/Utils/Objects";
import { log } from "@/Utils/Debug";

const isInvalidError = (str: string): boolean => {
  if (str.match(/capacitorDidRegisterForRemoteNotifications/gim)) {
    return true;
  } else if (str.match(/Only foreground notification/gim)) {
    return true;
  } else if (str.match(/NotAllowedError: play()/gim)) {
    return true;
  } else if (str.match(/obApi/gim)) {
    return true;
  } else if (str.match(/fbq/gim)) {
    return true;
  } else if (str.match(/failed to fetch/gim)) {
    return true;
  }

  return false;
};

export default (app: App, router: TcRouter) => {
  if (isValidString(config.sentryDsn)) {
    init({
      app,
      dsn: config.sentryDsn,
      integrations: [browserTracingIntegration({ router }), replayIntegration()],
      beforeSend(errorEvent, hint) {
        if (
          hasValue(hint) &&
          isValidString(hint.originalException) &&
          isInvalidError(hint.originalException)
        ) {
          return null;
        }

        if (hasValue(errorEvent) && hasValue(errorEvent.exception) && hasValue(errorEvent.exception.values)) {
          const isInvalid = hasValue(
            errorEvent.exception.values.find((err) => {
              if (!isValidString(err.value)) return false;

              return isInvalidError(err.value);
            })
          );

          if (isInvalid) {
            log("Invalid Error");

            return null;
          }
        }

        return errorEvent;
      },

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 0.1,

      // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost"],

      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 0.1,
    });
  }
};
